import { LayoutComponents } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";

import config from "appConfig";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 5,
        rows: 3,
        rowsSize: [6, 1, 1],
        colsSize: [1.1, 1, 1, 1, 1],
        colSpan: {
          "0:1": 4,
        },
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "Massive outer wall; layers (from outside to inside): thin render, 12 cm polystyrene,</br></br>25 cm brick, 2 cm plaster</br></br>Total thickness:</br>approx. 40 cm</br></br>Rw = 48 dB",
                    formatter: "html",
                    scrollbars: false,
                    styles: {
                      color: variables["text-secondary"],
                      fontSize: "14px",
                      lineHeight: "18px",
                      fontWeight: 400,
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  paddingTop: "50%",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/20/principle/facade-2.svg`,
                  },
                },
                styles: {
                  padding: "10% 0",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Source room sound",
                    scrollbars: false,
                  },
                },
                styles: {
                  justifyContent: "flex-start",
                  fontSize: "14px",
                  fontWeight: 700,
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "male voice",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/20/principle/source-male-voice.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "circular saw",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/20/principle/source-circular-saw.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "motorcycle",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/20/principle/source-motorcycle.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "truck",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/20/principle/source-truck.wav`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Receiving room sound",
                    scrollbars: false,
                  },
                },
                styles: {
                  justifyContent: "flex-start",
                  fontSize: "14px",
                  fontWeight: 700,
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "male voice",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/20/principle/facade-2-male-voice.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "circular saw",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/20/principle/facade-2-circular-saw.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "motorcycle",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/20/principle/facade-2-motorcycle.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "truck",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/20/principle/facade-2-truck.wav`,
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
